import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ScanLine } from "lucide-react";
import { Html5Qrcode } from "html5-qrcode";

export default function QrScanPage() {
  const navigate = useNavigate();
  const scannerRef = useRef(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let scanner = null;
    let stopped = false;

    const onDecode = (text) => {
      if (stopped) return;
      const match = text.match(/\/qr-approve\/([a-f0-9-]+)/i);
      if (match) {
        stopped = true;
        scanner?.stop().catch(() => {});
        navigate(`/qr-approve/${match[1]}`);
      }
    };

    try {
      scanner = new Html5Qrcode("qr-reader");
      scannerRef.current = scanner;
      scanner
        .start({ facingMode: "environment" }, { fps: 10, qrbox: { width: 240, height: 240 } }, onDecode, () => {})
        .catch(() => setError("Kameraya giriş mümkün olmadı. Kamera icazəsini yoxlayın"));
    } catch {
      setError("Kameraya giriş mümkün olmadı. Kamera icazəsini yoxlayın");
    }

    return () => {
      stopped = true;
      try { scanner?.stop().catch(() => {}); } catch { /* already stopped */ }
    };
  }, [navigate]);

  return (
    <div className="min-h-screen bg-black flex flex-col" data-testid="qr-scan-page">
      <div className="flex items-center gap-3 p-4">
        <button onClick={() => navigate(-1)} className="p-2 text-white hover:bg-white/10 rounded-lg transition-colors" data-testid="qr-scan-back">
          <ArrowLeft className="w-5 h-5" />
        </button>
        <h1 className="font-semibold text-white">TV QR kodunu oxudun</h1>
      </div>
      <div className="flex-1 flex flex-col items-center justify-center px-6">
        <div id="qr-reader" className="w-full max-w-sm rounded-2xl overflow-hidden" />
        {error ? (
          <p className="text-sm text-red-400 mt-6 text-center">{error}</p>
        ) : (
          <div className="flex items-center gap-2 mt-6 text-zinc-400 text-sm">
            <ScanLine className="w-4 h-4 text-blue-400" /> TV ekranındakı QR kodu kameraya tutun
          </div>
        )}
      </div>
    </div>
  );
}
